'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './template-list.routes';

export class TemplateListComponent {
  constructor(Auth, TemplateService, dialogs, DTOptionsBuilder, DTState) {
    'ngInject';

    this.TemplateService = TemplateService;
    this.data = [];

    this.dialogs = dialogs;

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('dom', 'lBfrtip')
      .withOption('order', [0, 'desc'])
      .withOption('stateSave',true)
      .withOption('stateSaveCallback', DTState.save())
      .withOption('stateLoadCallback', DTState.restore())
      .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
      .withOption('buttons',[{
        extend: 'excel',
        title: "Letter Templates"
      },{
        extend: 'csv',
        title: "Letter Templates"
      },{
        title: "Letter Templates",
        message: 'As of ' + moment().format("MMMM Do YYYY"),
        extend: 'pdf',
        orientation: 'portrait',
        pageSize: 'LETTER'
      },{
        extend: 'print',
        title: "Letter Templates"
      }]);

    this.TemplateService.query((data) => {
      this.data = data;
      this.dataInitComplete = true;
    }, err => {
      console.log("Could not retrieve templates.")
    });
  }

  delete(template) {
    var that = this;

    var templateText = "<br/><br/><b>" + template.name + "</b><br/><p>" + template.description + "</p>";

    var dlg = this.dialogs.confirm("Delete Template?", "Do you really want to delete this template?" + templateText);
    dlg.result.then(() => {
      // OK delete it
      that.TemplateService.delete({id: template._id},
        () => {
          that.data = that.data.filter(function( obj ) {
            return obj._id !== template._id;
          });
        },
        err => {
          alert("Could not delete template");
        });
    }, () => {
      // Cancel
    });
  }

}

export default angular.module('conduu.templateList', [uiRouter])
  .config(routes)
  .component('templateList', {
    template: require('./template-list.html'),
    controller: TemplateListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/template/template-list/template-list.component.js